// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__370wl","name":"ConsentHeader_name__26cYu","birthday":"ConsentHeader_birthday__3g0xC","skeleton":"ConsentHeader_skeleton__1f2pZ"};